<template>
  <transition name="fade" v-on:after-enter="$emit('update:show', false)">
		<div v-if="show" class="notif-box">{{ text }}</div>
	</transition>
</template>

<script>
export default {
  props: {
		text:String,
		show:Boolean,
	},
}
</script>

<style scoped>
.notif-box {
  position:fixed;
  z-index:1;
  padding:10px;
  right:10px;
  top:10px;
  width:auto;
  height:auto;
  border-radius:4px 4px 4px 4px;
  background-color:#36D7B7;
  color:white;
  font-size:1rem;
}
</style>
